import { render } from "./Test.vue?vue&type=template&id=deea537a&scoped=true"
import script from "./Test.vue?vue&type=script&lang=ts"
export * from "./Test.vue?vue&type=script&lang=ts"

import "./Test.vue?vue&type=style&index=0&id=deea537a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-deea537a"

export default script